import CXMApiClient from "../CXMApiClient";

const state = {};

const getters = {};

const actions = {
  getUnmatchedDMSSalesRecords(context, requestPayload) {
    return new Promise((resolve, reject) => {
      const cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/Dealsheet/entity/get_unmatched_dealsheet",
          requestPayload
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject();
        })
        .catch(resp => reject(resp));
    });
  },
  assignDealsheetToContact(context, requestPayload) {
    return new Promise((resolve, reject) => {
      const cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/crm/contacts/assign_dealsheet_to_contact",
          requestPayload
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject();
        })
        .catch(resp => reject(resp));
    });
  },
  createContactFromDealsheet(context, requestPayload) {
    return new Promise((resolve, reject) => {
      const cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/crm/contacts/create_contact_from_dealsheet",
          requestPayload
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject();
        })
        .catch(resp => reject(resp));
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/UnmatchedDMSSales.js